export type AreaOleoId =
  | 'sono'
  | 'disposicao'
  | 'foco'
  | 'memoria'
  | 'ansiedade'
  | 'peso'
  | 'dores'
  | 'medicamentos'
  | 'imunidade'
  | 'digestao'
  | 'sentimentos'
  | 'feminino'

export interface AreaOleo {
  id: AreaOleoId
  emoji: string
  titulo: string
  nomeScript: string
  oleos: string[]
  orientacao?: string
  chaves: string[]
}

export const AREAS_OLEOS: AreaOleo[] = [
  {
    id: 'sono',
    emoji: '😴',
    titulo: 'Sono',
    nomeScript: 'sono',
    oleos: ['Lavanda'],
    chaves: ['sono'],
  },
  {
    id: 'disposicao',
    emoji: '⚡',
    titulo: 'Disposição',
    nomeScript: 'disposição',
    oleos: ['Hortelã', 'Limão', 'Tangerina'],
    orientacao: 'Comece pelo Hortelã. Verifique contraindicações antes de indicar.',
    chaves: ['disposicao'],
  },
  {
    id: 'foco',
    emoji: '🎯',
    titulo: 'Foco',
    nomeScript: 'foco',
    oleos: ['Hortelã', 'Limão', 'Tangerina'],
    orientacao: 'Comece pelo Hortelã. Verifique contraindicações antes de indicar.',
    chaves: ['foco'],
  },
  {
    id: 'memoria',
    emoji: '🧬',
    titulo: 'Memória',
    nomeScript: 'memória',
    oleos: ['Olíbano'],
    chaves: ['memoria'],
  },
  {
    id: 'ansiedade',
    emoji: '🧠',
    titulo: 'Ansiedade',
    nomeScript: 'ansiedade',
    oleos: ['Balance', 'Copaíba', 'Breathe', 'Lavanda', 'Tangerina', 'Limão'],
    orientacao: 'Comece pelo Balance. Indique 3 óleos ou mais conforme a intensidade dos sintomas.',
    chaves: ['ansiedade'],
  },
  {
    id: 'peso',
    emoji: '⚖️',
    titulo: 'Peso e metabolismo',
    nomeScript: 'peso e metabolismo',
    oleos: ['MetaPWR'],
    chaves: ['peso'],
  },
  {
    id: 'dores',
    emoji: '💪',
    titulo: 'Dores e inflamação',
    nomeScript: 'dores e inflamação',
    oleos: ['Copaíba', 'Deep Blue', 'Olíbano'],
    orientacao: 'Comece pelo Copaíba. Indique o Deep Blue para dores musculares específicas.',
    chaves: ['dores'],
  },
  {
    id: 'medicamentos',
    emoji: '💊',
    titulo: 'Medicamentos',
    nomeScript: 'medicamentos',
    oleos: ['Copaíba', 'Olíbano'],
    chaves: ['medicamentos'],
  },
  {
    id: 'imunidade',
    emoji: '🛡️',
    titulo: 'Imunidade',
    nomeScript: 'imunidade',
    oleos: ['On Guard', 'Melaleuca', 'Olíbano'],
    orientacao: 'Comece pelo On Guard. Complemente com Melaleuca para questões de virose, pele e fungos.',
    chaves: ['inflamacoes'],
  },
  {
    id: 'digestao',
    emoji: '🌿',
    titulo: 'Digestão e intestino',
    nomeScript: 'digestão e intestino',
    oleos: ['ZenGest'],
    chaves: ['intestino'],
  },
  {
    id: 'sentimentos',
    emoji: '💔',
    titulo: 'Vergonha, culpa, apatia, tristeza, medo, escassez, raiva, orgulho, estagnação e desequilíbrio',
    nomeScript: 'sentimentos',
    oleos: ['Lavanda', 'Copaíba', 'Balance', 'Breathe', 'Tangerina'],
    orientacao: 'Indique um, dois ou outros conforme o perfil. Uma ótima opção é recomendar Lavanda e Copaíba juntos ou Balance e Breathe juntos.',
    chaves: ['vergonha', 'culpa', 'apatia', 'tristeza', 'medo', 'escassez', 'raiva', 'orgulho', 'estagnacao', 'desequilibrio'],
  },
  {
    id: 'feminino',
    emoji: '🌸',
    titulo: 'TPM, Menopausa, Libido e Equilíbrio Feminino',
    nomeScript: 'equilíbrio feminino',
    oleos: ['ClaryCalm'],
    chaves: [],
  },
]

const PRIORIDADE_IMPORTANCIA: {
  chave: string
  chaveResposta: string
  aliases: string[]
  frase: string
  oleo: string
  emocional?: boolean
}[] = [
  {
    chave: 'sono',
    chaveResposta: 'sono',
    aliases: ['sono e descanso', 'sono'],
    frase: 'Identifiquei que você está com dificuldades no sono e isso pode estar afetando o seu dia a dia.',
    oleo: 'Lavanda',
  },
  {
    chave: 'ansiedade',
    chaveResposta: 'ansiedade',
    aliases: ['ansiedade e estresse', 'ansiedade'],
    frase: 'Identifiquei que você está sentindo ansiedade e isso pode estar afetando o seu dia a dia.',
    oleo: 'Balance',
  },
  {
    chave: 'sentimentos',
    chaveResposta: 'sentimentos',
    aliases: [
      'tristeza e apatia',
      'medo e inseguranca',
      'raiva e irritabilidade',
      'estagnacao e bloqueios',
      'autoestima e merecimento',
      'equilibrio emocional geral',
      'vergonha', 'culpa', 'apatia', 'tristeza', 'medo', 'escassez', 'raiva', 'orgulho',
      'estagnacao', 'desequilibrio',
    ],
    frase: 'Identifiquei que você está com desequilíbrio emocional e isso pode estar afetando o seu dia a dia.',
    oleo: 'Lavanda',
    emocional: true,
  },
  {
    chave: 'dores',
    chaveResposta: 'dores',
    aliases: ['dores e inflamacoes', 'dores'],
    frase: 'Identifiquei que você está sentindo dores e isso pode estar afetando o seu dia a dia.',
    oleo: 'Copaíba',
  },
  {
    chave: 'disposicao',
    chaveResposta: 'disposicao',
    aliases: ['energia e disposicao', 'disposicao'],
    frase: 'Identifiquei que você está com cansaço e falta de energia e isso pode estar afetando o seu dia a dia.',
    oleo: 'Hortelã',
  },
  {
    chave: 'foco',
    chaveResposta: 'foco',
    aliases: ['foco e memoria', 'foco'],
    frase: 'Identifiquei que você está com dificuldades de foco e concentração e isso pode estar afetando o seu dia a dia.',
    oleo: 'Hortelã',
  },
  {
    chave: 'imunidade',
    chaveResposta: 'inflamacoes',
    aliases: ['imunidade e protecao', 'imunidade'],
    frase: 'Identifiquei que você está com imunidade baixa e isso pode estar afetando o seu dia a dia.',
    oleo: 'On Guard',
  },
  {
    chave: 'medicamentos',
    chaveResposta: 'medicamentos',
    aliases: ['medicamentos', 'medicamento'],
    frase: 'Identifiquei que você já tem desconfortos na sua saúde e isso pode estar afetando o seu dia a dia.',
    oleo: 'Copaíba',
  },
  {
    chave: 'intestino',
    chaveResposta: 'intestino',
    aliases: ['digestao e intestino', 'intestino'],
    frase: 'Identifiquei que você está com desconfortos digestivos e isso pode estar afetando o seu dia a dia.',
    oleo: 'ZenGest',
  },
  {
    chave: 'memoria',
    chaveResposta: 'memoria',
    aliases: ['memoria'],
    frase: 'Identifiquei que você está com dificuldades de memória e isso pode estar afetando o seu dia a dia.',
    oleo: 'Olíbano',
  },
  {
    chave: 'peso',
    chaveResposta: 'peso',
    aliases: ['peso e metabolismo', 'peso'],
    frase: 'Identifiquei que você está com oscilação de peso e alimentação emocional e isso pode estar afetando o seu dia a dia.',
    oleo: 'MetaPWR',
  },
]

const CHAVES_SENTIMENTOS = [
  'vergonha',
  'culpa',
  'apatia',
  'tristeza',
  'medo',
  'escassez',
  'raiva',
  'orgulho',
  'estagnacao',
  'desequilibrio',
  'sentimentos',
]

const FRASE_SENTIMENTOS =
  'Identifiquei que você está com desequilíbrio emocional e isso pode estar afetando o seu dia a dia.'

export const BENEFICIO_OLEO: Record<string, string> = {
  Balance: 'equilíbrio e estabilidade emocional',
  Lavanda: 'calma e sono reparador',
  Hortelã: 'energia e foco',
  Limão: 'clareza mental e leveza',
  Copaíba: 'equilíbrio emocional e da saúde',
  'Deep Blue': 'dores musculares e tensão',
  'On Guard': 'imunidade e proteção',
  Melaleuca: 'virose, pele e fungos',
  Olíbano: 'memória e equilíbrio da saúde',
  Tangerina: 'leveza emocional e alegria',
  Breathe: 'equilíbrio emocional e respiração',
  ZenGest: 'equilíbrio digestivo',
  MetaPWR: 'metabolismo e energia',
  ClaryCalm: 'equilíbrio hormonal feminino e emocional',
}

const condicoesTexto = (lead: any): string =>
  (lead?.condicoes_saude || []).map((c: string) => String(c || '').toLowerCase()).join(' | ')

const ehCriancaAbaixoDe6 = (lead: any): boolean => {
  const idade = Number(lead?.idade)
  return Number.isFinite(idade) && idade > 0 && idade < 6
}

const respostaEhSim = (valor: unknown): boolean => {
  if (valor === true || valor === 1) return true
  if (typeof valor !== 'string') return false
  const normalizado = valor.trim().toLowerCase()
  return normalizado === 'true' || normalizado === 'sim' || normalizado === '1' || normalizado === 'yes'
}

export const aplicarContraindicacoes = (oleo: string, lead: any): string => {
  const condicoes = condicoesTexto(lead)
  const gestanteOuAmamentando =
    condicoes.includes('gestante') || condicoes.includes('amament')
  const hipertensao = condicoes.includes('hipertens')
  const epilepsia = condicoes.includes('epilep')
  const crianca = ehCriancaAbaixoDe6(lead)

  if (epilepsia && oleo === 'Hortelã') return ''
  if ((gestanteOuAmamentando || crianca) && oleo === 'Hortelã') return 'Limão'
  if (hipertensao && oleo === 'Hortelã') return 'Tangerina'
  return oleo
}

export const pontuarArea = (area: AreaOleo, lead: any): number => {
  const respostas = lead?.respostas || {}
  let pontos = area.chaves.reduce((acc, chave) => acc + (respostaEhSim(respostas[chave]) ? 1 : 0), 0)
  if (area.id === 'feminino') {
    const condicoes = condicoesTexto(lead)
    if (condicoes.includes('endometriose') || condicoes.includes('menopausa')) pontos += 1
  }
  return pontos
}

const normalizarTexto = (valor: unknown): string =>
  String(valor || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()

const obterPrioridadesSelecionadas = (lead: any): string[] => {
  const lista = lead?.prioridades || lead?.prioridades_saude || []
  if (!Array.isArray(lista)) return []
  return lista.map(item => String(item || '').trim()).filter(Boolean)
}

const prioridadeCasaComItem = (prioridade: string, aliases: string[]): boolean => {
  const texto = normalizarTexto(prioridade)
  if (!texto) return false
  return aliases.some(alias => texto.includes(normalizarTexto(alias)))
}

export const obterPrioridadeScript = (lead: any): { sintoma: string; oleo: string; chave: string } => {
  const prioridades = obterPrioridadesSelecionadas(lead)

  for (const item of PRIORIDADE_IMPORTANCIA) {
    const selecionada = prioridades.some(p => prioridadeCasaComItem(p, item.aliases))
    if (!selecionada) continue
    const oleo = aplicarContraindicacoes(item.oleo, lead)
    if (!oleo) continue
    const sintoma = item.emocional ? FRASE_SENTIMENTOS : item.frase
    return { sintoma, oleo, chave: item.chaveResposta }
  }

  return {
    sintoma: 'Identifiquei que você está buscando mais equilíbrio na sua saúde e isso pode estar afetando o seu dia a dia.',
    oleo: aplicarContraindicacoes('Lavanda', lead) || 'Lavanda',
    chave: '',
  }
}

export const obterSintomaPrincipal = (lead: any): { area: AreaOleo; pontos: number; sintoma: string } => {
  const prioridade = obterPrioridadeScript(lead)
  const areaSentimentos = AREAS_OLEOS.find(a => a.id === 'sentimentos') || AREAS_OLEOS[0]
  const areaFisica = AREAS_OLEOS.find(a => a.chaves.includes(prioridade.chave)) || areaSentimentos
  const ehEmocional = CHAVES_SENTIMENTOS.includes(prioridade.chave)
  return {
    area: ehEmocional ? areaSentimentos : areaFisica,
    pontos: 1,
    sintoma: prioridade.sintoma,
  }
}

export const obterOleoPrioritario = (lead: any): string => obterPrioridadeScript(lead).oleo

export const obterBeneficioPrincipal = (oleo: string): string =>
  BENEFICIO_OLEO[oleo] || 'equilíbrio e bem-estar'
